<script lang="ts">
    import type {IMaintenanceData} from "../../data";

    export let data: IMaintenanceData;
</script>
<div class="productPreview mb-1">
    <div class="box relative">
        <a href={data.route}>
            <img class="w-100" src="{data.image}" alt="Product preview">
        </a>
        <!--div class="absolute favorite">
            <img height="35" src="/static/storefront/pix/icons/agregar-favoritos.svg" alt="Agregar a favoritos">
        </div-->
    </div>
    <div class="brand">{data.brand}</div>
    <div class="name">{data.name}</div>
</div>
<style>
    .favorite {
        right: .5rem;
        top: .5rem;
    }

    .brand {
        font-size: 12px;
        text-transform: uppercase;
        margin: .25rem 0;
    }

    .name {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: .25rem;
    }

    .type {
        background: var(--bg-gray);
        width: max-content;
        padding: .25rem;
        font-size: 12px;
        font-weight: 600;
        color: var(--text-gray);
        margin-bottom: .25rem;
    }

    .price {
        font-size: 18px;
    }

    .btn-cart {
        height: 45px;
        width: 45px;
        border-radius: 50%;
        cursor: pointer;
    }

    .discount {
        font-size: 12px;
        background: black;
        padding: .25rem;
        bottom: 0;
        left: 0;
        color: white;
        font-weight: 600;
    }
</style>